export default function Header({onHomeClick}) {
    const isHome = window.location.pathname === '/' || window.location.pathname === '';

    const handleClick = (e) => {
        if (isHome) {
            e.preventDefault();
            onHomeClick();
        }
    };

    return (
        <div className="w-full max-w-[1110px] mx-auto px-4 py-4 flex justify-between items-center">
            <a
                href="/"
                onClick={handleClick}
                className="flex flex-col items-start hover:opacity-80 transition"
            >
                <span className="text-2xl font-bold text-brand-dark">selebrus<span className="text-brand-red">.</span><span className="text-brand-dark/50">ru</span></span>
                <span className="text-[16px] text-brand-dark/50" style={{fontFamily: 'Poppins, sans-serif'}}>сервис поздравлен<span className="text-[20px] text-brand-red">ИИ</span>й</span>
            </a>
            <a
                href="/blog/"
                className="text-lg font-medium text-brand-dark hover:text-brand-red transition tracking-[-0.18px]"
            >
                Блог
            </a>
        </div>
    );
}
